import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import { log } from 'Src/utils/log';

import translation from './locales/en-us/translation.json';

void i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation
      }
    },
    lng: 'en', // if you're using a language detector, do not define the lng option
    fallbackLng: 'en',
    returnNull: false,
    returnEmptyString: true,
    // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    // TODO: change back when we pull in the translations keys from pos-components
    //  - pos-components has defaults applied... maybe we can omit this console from pos-components as it has a default
    interpolation: { escapeValue: false },
    react: { useSuspense: true },
    debug: false, // disable this
    saveMissing: true, // must be enabled
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      // console.warn(lng, ns, key, fallbackValue)
    },
  },
  (err) => {
    if (err) return log.error('i18n translation error: {err}', err);
    return log.info('i18n translation init complete');
  });
